export default "__VITE_PUBLIC_ASSET__a6b2f8b7__"